import React, { useState } from 'react';
import { HiMenuAlt4, HiX } from 'react-icons/hi';
import { motion } from 'framer-motion';
import './Navbar.scss';
import { images } from '../../constants';
const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <img src={images.thops3} alt="logo" className='nav-bar-blur' />
      </div>
      <ul className="app__navbar-links">
        {['home', 'work', 'skills', 'contact'].map((item, index) => (
          <li className="app_flex p-text" key={`link-${item}`}>
            <div />
            <a href={`#${item}`}>{item}</a>
          </li>
        ))}
      </ul>
      <div className='resume'>
        <a href='https://docs.google.com/document/d/e/2PACX-1vTzcmoRkrwGHE-w4aJ15yPaMNv7a5DuKB2Bn_BVlx84CbWg4mLw2YNtIR8b_Glm-A/pub' className='resume-btn'>
          <h1>Resume</h1>
        </a>
      </div>
      <div className="app__navbar-menu">

        <HiMenuAlt4 onClick={() => setToggle(true)} />

        {toggle && (
          <motion.div
            whileInView={{ x: [300, 0] }}
            transition={{ duration: 0.85, ease: "easeInOut" }}
          >
            <HiX onClick={() => setToggle(!toggle)} />
            <ul className="app__navbar-links">
              {['home', 'work', 'skills', 'contact'].map((item) => (
                <li key={item}>
                  <a href={`#${item}`} onClick={() => setToggle(!toggle)}>
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
